/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Category_BugInputs */



/**
* | output |
* | --- |
* | "Bug" |
*
* @param {Feedback_Category_BugInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_category_bug = /** @type {((inputs?: Feedback_Category_BugInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Category_BugInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bug")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Bug")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bug")
	return /** @type {LocalizedString} */ ("Bug")
});